/* eslint-disable react/prop-types */
import qs from 'qs';
import React, { useEffect, useMemo } from 'react';
import { withRouter } from 'react-router';
import { useSelector } from 'react-redux';

import { useActions } from '@src/containers/InfoModals/hooks';
import * as contactsHooks from '@src/containers/ContactsModal/hooks';
import { ENTITY_TYPES } from '@src/containers/ContactsModal/constants';
import { profileDetails } from '@src/containers/ProfileVenue/selectors';
import { selectors as profileSelectors } from '@src/containers/ProfileVenue';
import { isMediaPreviewModalOpened } from '@src/containers/InfoModals/selectors';
import { getFuncAlbums } from '@src/containers/ProfileVenue/selectors/getFuncAlbums';

import MediaPreviewCCommon from './common';

const MediaPreviewCVenue = withRouter((props) => {
	const { fullscreen, location } = props;
	const { closeMediaPreviewModal, openMediaPreviewModal, setMediaPreviews } =
		useActions();
	const isOpened = useSelector(isMediaPreviewModalOpened);
	const user = useSelector(profileDetails);
	const { toggleStandaloneModal } = contactsHooks.useActions();
	const rooms = useSelector(profileSelectors.profileRoomsMapped);
	const { albums } = useSelector(getFuncAlbums);

	const [targetId, targetIdx, targetType] = useMemo(() => {
		const q = qs.parse(location.search, { ignoreQueryPrefix: true });
		const targetCodes = ['media', 'album_media'];
		for (let i = 0; i < targetCodes.length; i += 1) {
			const code = targetCodes[i];
			if (q[code]) {
				const r = q[code].split('_').map((k) => Number.parseInt(k, 10));
				const result = r.map((k) => (Number.isNaN(k) ? undefined : k));
				result.push(code);
				return result;
			}
		}
		return [];
	}, [location.search]);

	useEffect(() => {
		try {
			let medias = [];
			let title;
			if (targetType === 'media') {
				const targetRoom = rooms.find(({ id }) => id === targetId);
				if (targetRoom) {
					medias = targetRoom?.covers || [];
					title = targetRoom.title;
				}
			}
			if (targetType === 'album_media') {
				const targetAlbum = albums.find(({ id }) => id === targetId);
				if (targetAlbum) {
					medias = targetAlbum.media.map((i) => {
						if (typeof i === 'number') {
							return { src: i };
						}
						return i;
					});
					title = targetAlbum.title;
				}
			}

			if (medias.length === 0) {
				setMediaPreviews();
				closeMediaPreviewModal();
				return;
			}

			if (!isOpened) {
				setMediaPreviews({
					medias,
					current: targetIdx,
					details: { title },
				});
				openMediaPreviewModal();
			}
		} catch (err) {
			// eslint-disable-next-line no-console
			console.error(err);
		}
	}, [
		isOpened,
		// loftMedias,
		setMediaPreviews,
		openMediaPreviewModal,
		closeMediaPreviewModal,
		targetId,
		targetIdx,
		rooms,
		targetType,
		albums,
	]);

	const avatarProps = React.useMemo(() => {
		return {
			name: user.name,
			about: t('Ресторан'),
		};
	}, [user]);

	const handleClickContacts = React.useCallback(() => {
		toggleStandaloneModal({
			isVisible: true,
			target: {
				entityId: user.id,
				entityType: ENTITY_TYPES.VENUE,
			},
		});
	}, [toggleStandaloneModal, user.id]);

	return (
		<MediaPreviewCCommon
			targetCode={targetId}
			targetType={targetType}
			fullscreen={fullscreen}
			onClickContacts={handleClickContacts}
			placeTitle={user?.name}
			avatarProps={avatarProps}
		/>
	);
});

export default MediaPreviewCVenue;
